import { makeStyles } from "@material-ui/core";

export default makeStyles(({ spacing, palette }) => ({
  header: {
    display: "flex",
    flexDirection: "column",
    gap: spacing(2),
  },
  emailContainer: {
    display: "flex",
    flexDirection: "column",
    gap: spacing(2),
    padding: spacing(2),
    borderRadius: "12px",
    border: `1px solid ${palette.emailSeparator.main}`,
  },
  logosContainer: {
    display: "flex",
    justifyContent: "center",
  },
  emailBody: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: spacing(2),
  },
  secondaryText: {
    padding: spacing(3),
    background: palette.contrastEmailWrapper.main,
    border: `1px solid ${palette.emailSeparator.main}`,
    borderRadius: "8px",
    width: "100%",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 400,
    color: palette.contrastEmailText.main,
  },
  logo: {
    width: 80,
    height: 80,
    border: "1px solid #E0E0E0",
    borderRadius: spacing(1),
    "& + &": {
      marginLeft: spacing(2),
    },
  },
  greeting: {
    width: "100%",
    color: palette.contrastText.main,
    fontSize: spacing(3),
    fontWeight: 500,
    textAlign: "center",
    marginBottom: spacing(3),
  },
  emailText: {
    textAlign: "center",
    color: palette.contrastText.main,
    fontWeight: 500,
    fontSize: "18px",
  },
  submitButton: {
    display: "flex",
    margin: "0 auto",
    padding: spacing(1, 2),
    flex: "0 1 auto",
    height: 40,
    textAlign: "center",
    background: palette.primary.main,
    color: palette.common.white,
    borderRadius: spacing(2.5),
    textTransform: "uppercase",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 600,
    marginTop: spacing(3),
  },
}));
